import { BasicFrame } from 'components/organisms';
import { ButtonActor } from 'components/actors';
import { datadogReportLogs } from 'utils/tinkReports';
import { frameConfigBasic } from '../../../AppConfig';
import { getScreenTranslation } from '../../../utils/translations';
import { Loading } from 'components/molecules';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TinkWaiting.module.scss';
import useClient from 'hooks/useClient';
import useFirebase from 'hooks/useFirebase';
import useTinkWaiting from './useTinkWaiting';

export default function TinkWaiting() {
  const { isProcessing, checkParams } = useTinkWaiting();
  const i18Next = useTranslation();
  const { client } = useClient();
  const { firebaseData } = useFirebase();
  const content = getScreenTranslation(
    'online_bank_identification_waiting',
    i18Next,
  );

  useEffect(() => {
    if (firebaseData.REGISTRATION_DATADOG_LOGS_INFO && client?.id) {
      datadogReportLogs('tinkWaiting', client);
    }
  }, [client?.id, firebaseData.REGISTRATION_DATADOG_LOGS_INFO]);

  return (
    <BasicFrame
      {...frameConfigBasic}
      hideLogout
      hideMobileFooter
      logoSquare
      logo
    >
      {isProcessing ? (
        <div className={styles['container']}>
          <Loading text={content.subtitle} title={content.title} />
        </div>
      ) : (
        <div className={styles['container']}>
          <ButtonActor buttonProps={{ onClick: checkParams }}>
            {content.submit_btn}
          </ButtonActor>
        </div>
      )}
    </BasicFrame>
  );
}
